import { render } from "./index.vue?vue&type=template&id=2421b4ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2421b4ce&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2421b4ce"]])

export default __exports__